export default value => {
    const div = document.createElement('div');

    div.innerHTML = value;

    const text = div.textContent || div.innerText || '';

    if (text && text.length > 80) {
        return `${text.substring(0, 80)}...`;
    }

    return text;
};
